import { scrollToAnchor } from "@/app/hooks/useScrollSmooth";
import Link from "next/link";
const MobileNavBar = ({ closeMenu }: { closeMenu?: () => void }) => {
  const links = [ "Ester", "Sua jornada", "Diferenciais", "Nossa história", "Serviços"];
  return (
    <nav className="flex flex-col gap-4">
      {links.map((link, i) => (
        <Link
          key={i}
          scroll={false}
          href={`#${link
            .replace(" ", "-")
            .replace("ó", "o")
            .replace("ç", "c")
            .toLocaleLowerCase()}`}
          className="text-gray-700 hover:text-[hsl(var(--accent))] transition-colors duration-300 z-100"
          onClick={() => {
            scrollToAnchor(
              link
                .replace(" ", "-")
                .replace("ó", "o")
                .replace("ç", "c")
                .toLocaleLowerCase()
            );
            if (closeMenu) closeMenu();
          }}
        >
          {link}
        </Link>
      ))}
    </nav>
  );
};

export default MobileNavBar;
